import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildCanonicalUrl, isIndexablePath } from '@/lib/seo';

// Atualiza (ou cria) uma meta tag no <head>.
const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// Atualiza (ou cria) o link canônico no <head>.
const upsertCanonical = (href: string) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

/**
 * Mantém o canônico e o og:url sincronizados com o domínio definitivo,
 * apontando cada página para si mesma (e não todas para a home).
 * Rotas internas/admin e páginas utilitárias recebem noindex.
 */
export default function SeoCanonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isIndexablePath(pathname)) {
      const url = buildCanonicalUrl(pathname);
      upsertCanonical(url);
      upsertMeta('property', 'og:url', url);
      upsertMeta('name', 'robots', 'index, follow');
    } else {
      upsertMeta('name', 'robots', 'noindex, nofollow');
    }
  }, [pathname]);

  return null;
}